import React from "react";
import { Typography } from "antd";
import styles from "../style/SendEmailModal.module.css";
const { Text } = Typography;

const RecipientList = ({ data, sourcePlace }) => (
  <div style={{ fontSize: "18px", }}>
    {sourcePlace === 'CONFIRM_MODAL' && <div style={{ fontSize: '18px', fontWeight: 'bold', color: '#333', marginBottom: '12px', }}>
      Agents
    </div>}
    <div>
      {data?.map((el, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            alignItems: "center",
            marginLeft: sourcePlace === "CONFIRM_MODAL" && "-25px",
          }}
        >
          <span className={styles.bulletPoint}>•</span>
          <div
            style={{
              display: "flex",
              whiteSpace: "nowrap",
              paddingRight: 0,
              overflow: sourcePlace === "CONFIRM_MODAL" && "hidden",
              textOverflow: sourcePlace === "CONFIRM_MODAL" && "ellipsis",
            }}
          >
            <span className={styles.fullName}>{el?.fullName}</span>
            <span className={styles.dash}>-</span>
            <Text className={styles.email} ellipsis>
              {el?.email}
            </Text>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default RecipientList;
